import React, { useEffect, useState } from "react"
import { useRouter } from "next/router"
import Highlighter from "react-highlight-words"
import Button from "../Buttons/Button"
import TextField from "../Inputs/TextField"
import { getAutoCompleteResults } from "../../../lib/wineRequests"

const BaseWineSearchBar = (props: {
  className?: string
  hideResults?: boolean
  onSearch?: Function
  value?: string
  type?: string
}) => {
  const [term, setTerm] = useState(props.value || "")
  const [showResults, setShowResults] = useState(false)
  const [autoFillOptions, setAutoFillOptions] = useState([])
  const router = useRouter()

  const handleBlur = () => {
    setShowResults(false)
  }

  const handleSearch = async (val) => {
    if (val && val.length !== 0) {
      const response = await getAutoCompleteResults(encodeURIComponent(val))
      if (response.status === 200) {
        setAutoFillOptions([...response.data])
      }
    }
  }

  const onFocus = () => {
    setShowResults(true)
  }

  const handleChange = (e) => {
    term.length === 0 && setAutoFillOptions([])
    if (e && e.target) {
      const val = e.target.value
      setTerm(val)
    }
  }

  const handleEnter = (option?: any) => {
    setAutoFillOptions([...autoFillOptions])
    setShowResults(false)
    if (!props.onSearch) {
      const termQuery = option ? "?term=" + option.label : term ? "?term=" + term : ""
      router.push("/wines" + termQuery)
    } else {
      if (option && option.slug && option.vintage) {
        router.push(`/wines/${option.slug}/${option.vintage}`)
      } else {
        props.onSearch(option && option.label ? option.label : term)
      }
    }
  }

  useEffect(() => {
    const timeOutId = setTimeout(() => handleSearch(term), 1000)
    return () => {
      clearTimeout(timeOutId)
    }
  }, [term])

  return (
    <div
      className={`relative outline-none z-20 ${props.className}`}
      onBlur={handleBlur}
    >
      <div className="flex justify-end items-center z-40">
        <TextField
          className="border-r-0 rounded-r-none w-full"
          placeholder="Search for..."
          type="search"
          value={term}
          onFocus={onFocus}
          onEnter={handleEnter}
          onChange={handleChange}
        />
        <Button
          type="primary"
          className="rounded-l-none"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="48"
              fill="none"
              viewBox="0 0 32 32"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          }
          onClick={(e) => {
            handleEnter()
          }}
        />
      </div>
      {autoFillOptions.length > 0 && showResults && (
        <div className="w-full absolute top-10 max-h-72 rounded-t-none rounded bg-white border-gray-200 border border-t-0 shadow-lg grid overflow-scroll">
          <div className="bg-red text-white font-semibold text-center px-3 py-2">
            PRESS ENTER FOR FULL RESULTS
          </div>
          {autoFillOptions.map((option, i) => {
            return (
              <div
                key={i}
                className="p-2 w-full hover:bg-gray-200 cursor-pointer "
                onMouseDown={() => handleEnter(option)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleEnter(option)
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <Highlighter
                  highlightTag="span"
                  highlightClassName="underline font-semibold"
                  highlightStyle={{ textDecorationColor: "#dc2626" }}
                  searchWords={[term]}
                  autoEscape={true}
                  textToHighlight={option.label || ""}
                />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default BaseWineSearchBar
